import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: #52403A;
    line-height: 1.25;
    background: #F2EEE8;
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scrollbar-color: #F2EEE8 #DDD2C4;
    &::-webkit-scrollbar-track {
      background: #DDD2C4;
    }
    &::-webkit-scrollbar-thumb {
      background: #F2EEE8;
    }
  }
  body{
    overflow-y: scroll;
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Neuzeit Grotesk', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: #52403A;
    transition: all 0.25s ease 0s;
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  button { font-weight: 400; }
  .home-content {
    will-change: transform; 
  }
  /* ----- react-select ----- */
  @keyframes selectSlideInOut {
    0% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* ----- For br ----- */
  .for-mobile {
    display: none;
  }
  ${mediaMax('mobile')} {
    .for-desktop {
      display: none;
    }
    .for-mobile {
      display: inline;
    }
  }

  /* ----- UserWay ----- */
  body .uwy {
    opacity: 1;
    visibility: visible;
    transition: opacity 2s, visibility 2s;
    z-index: 50 !important;
    &.hide {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0s, visibility 0s;
    }
  }
  body .uwy > .userway_buttons_wrapper  {
    top: auto !important;
    bottom: ${calculateResponsiveSize(20)} !important;
    right: ${calculateResponsiveSize(24)} !important;
    left: auto !important;
    transform: none !important;
    ${mediaMax('mobile')} {
      bottom: ${calculateMobileResponsiveSize(20)} !important;
      right: ${calculateMobileResponsiveSize(24)} !important;
    }
  }
  body .uwy .uai, body .uwy .uai > span {
    width: ${calculateResponsiveSize(40)} !important;
    height: ${calculateResponsiveSize(40)} !important;
    ${mediaMax('mobile')} {
      width: ${calculateMobileResponsiveSize(30)} !important;
      height: ${calculateMobileResponsiveSize(30)} !important;
    }
  }
  body .uwy .uai > span > img {
    width: 100% !important;
    height: auto !important;
  }
`

export default GlobalStyle
